import React from 'react';
import ReactDOM from 'react-dom';
import './muiOverride.css';
import './bcio.css';
import App from './App.jsx';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import store from './redux-store'


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>, 
  document.getElementById('root'));
//registerServiceWorker();
